/* eslint no-underscore-dangle: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import FileFormat from '../FileFormat';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import PopupBox from '../ContentUploadConfirmation';
import Logo from '../../../../assets/images/Template_31/Logo.png';

function HtmlTemplateThirtyThree({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [openContentUploadConfirmation, setOpenContentUploadConfirmation] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);

  const cssStyles = `
    body {
      margin: 0;
      padding: 0;
    }
    .supersale-card {
      position: relative;
      font-family: "Montserrat", sans-serif;
      box-sizing: border-box;
      overflow: hidden;
      height: 93.6vh;
      padding: 30px 45px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
      color: #FFF;
    }
    .supersale-card__header {
      width: 100%;
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 7px;
    }
    .supersale-card__header h3 {
      color: #FFF;
      font-size: clamp(18px, 2vw, 24px);
    }
    .supersale-card__header img {
      width: clamp(18px, 2vw, 25px);
      height: clamp(18px, 2vw, 25px);
    }
    .supersale-card__content {
      gap: 40px;
      display: flex;
      justify-content: space-between;
      height: max-content;
    }
    .supersale-card__content__text {
      margin-top: 50px;
      gap: 30px;
      display: flex;
      flex-direction: column;
    }
    .supersale-card__content__text__label {
      margin: 0;
      width: max-content;
      font-size: 28px;
      font-weight: 700;
      padding: 12px 70px;
      border-radius: 8px;
      text-align: center;
      border: 2px solid #FFF;
    }
    .supersale-card__content__text__subtitle {
      margin: 0;
      font-size: 70px;
      font-weight: 700;
    }
    .supersale-card__content__text__title {
      margin: 0;
      font-size: 90px;
      font-weight: 700;
      color: #EFD003;
    }
    .supersale-card__content__text__description {
      margin: 0;
      font-size: 30px;
      font-weight: 500;
      text-transform: capitalize;
    }
    .supersale-card__content__text__button {
      border: none;
      outline: none;
      width: 200px;
      padding: 20px 30px;
      font-size: 25px;
      font-weight: 600;
      border-radius: 10px;
      color: #000;
      cursor: pointer;
      transition: 0.3s ease;
    }
    .supersale-card__content__text__button:hover {
      background-color: #c7ad02;
      transform: translateY(-3px);
    }
    .supersale-card__content__image {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
    }
    .supersale-card__content__image .image-reflection {
      display: flex;
      justify-content: end;
      position: relative;
      width: 100%;
      max-width: 500px;
    }
    .supersale-card__content__image .image-reflection__image {
      width: 100%;
      height: auto;
    }
    .supersale-card__content__image .image-reflection__arrow {
      width: 200px;
      height: auto;
      position: absolute;
      top: 50px;
      inset-inline-end: -30px;
      object-fit: contain;
      transition: all 0.3s ease-in-out;
    }
    .supersale-card__content__image__offer {
      margin: 0;
      display: flex;
      color: #EFD003;
      font-size: 50px;
      font-weight: 700;
      text-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
      transition: font-size 0.3s ease-in-out;
    }
    .supersale-card__footer {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      margin-top: 70px;
    }
    .supersale-card__footer li {
      list-style: none;
      font-size: clamp(18px, 2vw, 24px);
      font-weight: 500;
    }
    .supersale-card__footer__address {
      text-transform: capitalize;
    }
    @media (max-width: 1200px) {
      .supersale-card__content {
        gap: 30px;
      }
      .supersale-card__content__text__title {
        font-size: 70px;
      }
      .supersale-card__content__text__subtitle {
        font-size: 50px;
      }
      .supersale-card__content__text__description {
        font-size: 24px;
      }
      .supersale-card__content__image .image-reflection__arrow {
        width: 140px;
        top: 50px;
        inset-inline-end: -20px;
      }
      .supersale-card__content__image__offer {
        font-size: 32px;
      }
    }
    @media (min-width: 992px) and (max-width: 1180px) {
      .supersale-card__content__image .image-reflection__arrow {
        width: 80px;
        top: 20px;
        inset-inline-end: -20px;
      }
      .supersale-card__content__image__offer {
        font-size: 32px;
      }
    }
    @media (max-width: 992px) {
      .supersale-card {
        height: auto;
        padding: 25px 30px;
      }
      .supersale-card__content {
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
      .supersale-card__content__text {
        align-items: center;
        margin-top: 30px;
      }
      .supersale-card__content__text__label {
        font-size: 22px;
        padding: 10px 40px;
      }
      .supersale-card__content__text__subtitle {
        font-size: 48px;
      }
      .supersale-card__content__text__title {
        font-size: 64px;
      }
      .supersale-card__content__text__description {
        font-size: 20px;
        max-width: 500px;
      }
      .supersale-card__content__text__button {
        font-size: 20px;
        padding: 15px 25px;
      }
      .supersale-card__content__image .image-reflection {
        max-width: 400px;
      }
      .supersale-card__content__image .image-reflection__arrow {
        width: 130px;
        top: 30px;
        inset-inline-end: -10px;
      }
      .supersale-card__content__image__offer {
        font-size: 38px;
      }
      .supersale-card__footer {
        flex-direction: column;
        text-align: center;
        margin-top: 50px;
        gap: 10px;
      }
    }
    @media (max-width: 576px) {
      .supersale-card {
        padding: 20px 15px;
      }
      .supersale-card__content {
        gap: 20px;
      }
      .supersale-card__content__text {
        gap: 15px;
      }
      .supersale-card__content__text__label {
        font-size: 18px;
        padding: 8px 25px;
      }
      .supersale-card__content__text__subtitle {
        font-size: 32px;
      }
      .supersale-card__content__text__title {
        font-size: 42px;
      }
      .supersale-card__content__text__description {
        font-size: 16px;
      }
      .supersale-card__content__text__button {
        font-size: 16px;
        padding: 10px 20px;
      }
      .supersale-card__content__image .image-reflection {
        max-width: 280px;
      }
      .supersale-card__content__image .image-reflection__arrow {
        width: 100px;
        top: 20px;
        inset-inline-end: 0px;
      }
      .supersale-card__content__image__offer {
        font-size: 24px;
      }
      .supersale-card__footer {
        margin-top: 40px;
      }
      .supersale-card__footer li {
        font-size: 16px;
      }
    }
  `;

  const convertImage = async (url) => {
    await utils.convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertBase64 = async () => {
    toPng(htmlRef?.current, { cacheBust: true })
      .then((dataUrl) => {
        setBase64(dataUrl);
        convertImage(dataUrl);
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertHtml = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => (setData(res)));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data) {
      /* used settimeout the page was fully rendered and then called the api so wait for the response */
      setTimeout(() => {
        convertBase64();
      }, 1000);
      convertHtml();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: <TemplateContentUpload
        base64={base64}
        setNotification={setNotification}
        fileType={fileType}
        htmlContent={htmlContent}
      />,
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: <FileFormat
        setNotification={setNotification}
        handleFileType={handleFileType}
        setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
        data={data}
      />,
    });
  };

  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const backgroundImage = Array.isArray(data?.[0]?.template_backgroundImage_url)
    ? data?.[0]?.template_backgroundImage_url
    : [];
  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />

      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: <PopupBox
            setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
            setNotification={setNotification}
          />,
        }}
      />

      <div className="header-height" />
      <div
        ref={htmlRef}
        className="supersale-card"
        style={{ backgroundImage: `url(${backgroundImage?.[1]})` }}
      >
        <div className="supersale-card__header">
          <img src={Logo} alt="Logo" />
          <h3>{contentDetails?.[0]?.header.toUpperCase()}</h3>
        </div>

        <div className="supersale-card__content">
          <div className="supersale-card__content__text">
            <p className="supersale-card__content__text__label">Limited Time Offer</p>
            <h3 className="supersale-card__content__text__subtitle">{contentDetails?.[0]?.sale.toUpperCase()}</h3>
            <h1 className="supersale-card__content__text__title">{contentDetails?.[0]?.item_name.toUpperCase()}</h1>
            <p className="supersale-card__content__text__description">{contentDetails?.[0]?.description}</p>
            <button type="button" className="supersale-card__content__text__button">Visit Now</button>
          </div>

          <div className="supersale-card__content__image">
            <div className="image-reflection">
              <img className="image-reflection__image" src={contentDetails?.[0]?.image} alt="Product" />
              <img className="image-reflection__arrow" src={backgroundImage?.[0]} alt="Arrow descoration" />
            </div>
            <h3 className="supersale-card__content__image__offer">{contentDetails?.[0]?.offer_percentage} OFF</h3>
          </div>
        </div>

        <ul className="supersale-card__footer">
          <li className="supersale-card__footer__address">{contentDetails?.[0]?.address}</li>
          <li className="supersale-card__footer__website">{contentDetails?.[0]?.website}</li>
        </ul>
      </div>
    </div>
  );
}

HtmlTemplateThirtyThree.propTypes = {
  templateData:
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      template_title: PropTypes.string.isRequired,
    }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateThirtyThree;
